const en = {
  dashboard: {
    title: "DASHBOARD",
    greeting: "Hello",
    new_policy: "New policy",
    new_client: "New client",
    clients_actifs: "Active clients",
    dossiers_etude: "Files under review",
    prime_annuelle: "Annual premium",
    polices_actives: "active policies",
    sinistres_ouverts: "open claims",
    a_traiter: "Files to process",
    rien_a_traiter: "No pending files — all up to date",
    portefeuille: "Portfolio",
    polices: "policies",
    dash_st_validation: "Validation",
    dash_st_pieces: "Documents",
    dash_st_demande: "Request",
  },
  lang: { fr: 'Français', en: 'English', de: 'Deutsch', sv: 'Svenska' },

  nav: { rcpro_studies: "Study requests", gf_studies: "Study requests", gf_requests: "Opening requests", gf_declarations: "Turnover declarations",
    voyageur_subtitle: 'Complete your compensation file',
    acces_deja: 'A traveller account already exists for this file',
    role_voyageur: 'Traveller',
    creer_acces_client: "Create client access",
    creer_acces_client_subtitle: "Create an account for the client to manage their policies online.",
    acces_client_cree: "Client access created — send credentials to client",
    acces_client_deja: "A client account already exists for this account",
    client_space: "My client space",
    client_mes_polices: "My policies",
    role_client: "Client",
    dashboard: "Dashboard",
    section_pilotage: "Overview",
    role_manager: 'Manager',
    role_souscripteur: 'Admin',
    role_accounts: 'Accounts',
    role_it: 'IT',
    role_courtier: 'Broker',
    role_client: 'Client',
    section_sinistres: 'Claims',
    section_gestion: 'Management',
    section_portfolio: 'Portfolio',
    section_administration: 'Administration',
    utilisateurs: 'User accounts',
    intermediaires: 'Brokers & Intermediaries',
    sinistres: 'Claims Management',
    clients: 'Clients',
    polices: 'Professional Liability',
    gf: 'Financial Guarantee',
    crm_subtitle: 'CRM',
    prestataires: 'Suppliers & TOs',
    closed_dossiers: 'Closed dossiers',
    pending_payment: 'Pending payment',
    pending_balances: 'Pending balances',
    pending_validation: 'Pending validation',
    gestion_doc: "Document management",
  },

  common: { edit: "Edit", modifier: "Edit",
    saved: 'Saved',
    ok: 'OK',
    save: 'Save',
    saving: 'Saving…',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    deleting: 'Deleting…',
    open: 'Open',
    modify: 'Edit',
    consult: 'View',
    generate: 'Generate',
    close: 'Close',
    previous: '← Previous',
    next: 'Next →',
    yes: 'Yes',
    no: 'No',
    loading: 'Loading…',
    creating: 'Creating…',
    slide: 'Step',
    of: '/',
    all_countries: 'All countries',
    all_statuses: 'All statuses',
    actions: 'Actions',
    status: 'Status',
    country: 'Country',
    none: '—',
    not_found: 'Not found.',
    no_results: 'No results found.',
    error: 'Error',
    access_denied: 'Access denied',
    required: '*',
    optional: '(optional)',
    irreversible: 'This action cannot be undone.',
    auto_generated: 'Auto-generated',
    locked: 'Locked',
    consultation_only: '🔒 View only',
    generate_coming_soon: 'Template coming soon',
    download: '⬇ Generate',
    locked_after_binding: '🔒 Available after binding',
    locked_after_activation: '🔒 After activation',
    yes_col: 'Yes',
    no_col: 'No',
    suspend: 'Suspend',
    reactivate: 'Reactivate',
    unlock_btn: 'Unlock',
    unlock_confirm: 'Reset this document to pending validation?',
    doc_gf_cert_immat: 'Registration certificate',
    doc_gf_statuts: 'Company articles of association',
    doc_gf_cv_dirigeant: "Director's CV",
    doc_gf_piece_id: "Director's identity document",
    doc_gf_presentation_projet: 'Project presentation',
    doc_gf_previsionnel: 'Detailed business forecast',
    doc_gf_cgv: 'General terms and conditions of sale',
    doc_gf_presentation_activites: 'Activity presentation',
    doc_gf_previsionnel_annuel: 'Business forecast for the guaranteed year',
    doc_gf_bilan_cr: 'Latest detailed balance sheet and P&L',
    doc_gf_attestation_rcpro: 'Current PI insurance certificate',
    doc_gf_attestation_fonds: 'Held funds peak certificate',
    readonly_banner: 'Read-only view — upload and preview only',
    broker_readonly: 'As a broker, you can only view client records.',
    address_siege: 'Registered address',
    broker_status_locked: 'Prospect — status defined by Arcus underwriter',
    accepted_label: 'accepted',
    required_label: 'Required',
    delete_btn: '🗑 Delete',
    doc_contrat_reservation: 'Copy of the booking contract with the agency',
    doc_preuve_paiement: 'Proof of payment(s)',
    doc_bon_voucher: 'Unused voucher (if applicable)',
    delete_confirm: 'Delete',
    coming_soon: "Feature coming soon",
  },

  status: { devis_rcpro: "Quote (awaiting documents)", demande_pieces: "Documents & information requested", en_cours_etude: "Under review", demande_ouverture: "Request pending", demande_refusee: "Request declined",
    actif: 'Active',
    suspendu: 'Suspended',
    prospect: 'Prospect',
    client_actif: 'Active client',
    devis: 'Quote',
    souscrit: 'Bound',
    resilie: 'Terminated',
    sans_objet: 'N/A',
    amende: 'Amended',
    projet_avenant: 'Amendment draft',
    avenant_actif: 'Active amendment',
    remplace: 'Superseded',
    en_vigueur: 'In force',
    renouvellement: 'Renewal',
    en_souscription: 'Pending binding',
    renouvelee: "Renewed",
  },

  intermediaires: {
    title: 'Broker & Intermediary Management',
    create_btn: '+ Create intermediary',
    search_placeholder: 'Search by name, type, professional number…',
    count: 'intermediary',
    count_plural: 'intermediaries',
    not_assignable: '· Cannot be assigned to a client',
    col_name: 'NAME / ORGANISATION',
    col_type: 'TYPE',
    col_country: 'COUNTRY',
    col_status: 'STATUS',
    col_actions: 'ACTIONS',
    type_courtier: 'Broker',
    type_avocat: 'Lawyer',
    type_association: 'Association',
    type_formation: 'Training organisation',
    contacts_count: 'contact',
    contacts_count_plural: 'contacts',
    unlock_btn: 'Unlock',
    unlock_confirm: 'Reset this document to pending validation?',
    doc_gf_cert_immat: 'Registration certificate',
    doc_gf_statuts: 'Company articles of association',
    doc_gf_cv_dirigeant: "Director's CV",
    doc_gf_piece_id: "Director's identity document",
    doc_gf_presentation_projet: 'Project presentation',
    doc_gf_previsionnel: 'Detailed business forecast',
    doc_gf_cgv: 'General terms and conditions of sale',
    doc_gf_presentation_activites: 'Activity presentation',
    doc_gf_previsionnel_annuel: 'Business forecast for the guaranteed year',
    doc_gf_bilan_cr: 'Latest detailed balance sheet and P&L',
    doc_gf_attestation_rcpro: 'Current PI insurance certificate',
    doc_gf_attestation_fonds: 'Held funds peak certificate',
    readonly_banner: 'Read-only view — upload and preview only',
    broker_readonly: 'As a broker, you can only view client records.',
    address_siege: 'Registered address',
    broker_status_locked: 'Prospect — status defined by Arcus underwriter',
    accepted_label: 'accepted',
    required_label: 'Required',
    delete_btn: '🗑 Delete',
    doc_contrat_reservation: 'Copy of the booking contract with the agency',
    doc_preuve_paiement: 'Proof of payment(s)',
    doc_bon_voucher: 'Unused voucher (if applicable)',
    delete_confirm: 'Are you sure you want to delete',
    new_title: 'New intermediary',
    edit_title: 'Edit intermediary',
    breadcrumb: 'Intermediaries',
    tab_profile: 'Profile',
    tab_contacts: 'Contacts',
    tab_contract: 'Contract terms',
    type_label: 'Type *',
    courtier_fields_title: 'BROKER-SPECIFIC FIELDS',
    professional_number: 'Professional number',
    reference_code: 'Broker reference code',
    professional_number_placeholder: 'e.g. CIF-FR-123456',
    reference_code_placeholder: 'e.g. ARC-2024-001',
    structure_name: 'Organisation name *',
    legal_status: 'Legal status',
    registration_number: 'Registration number',
    registration_placeholder: 'e.g. 12345678900012',
    addresses: 'ADDRESSES',
    main_address: '🏠 Main address',
    add_address: '+ Add address',
    address_line1: 'Address line 1',
    address_line2: 'Address line 2',
    postal_code: 'Postal code',
    city: 'City',
    address1_placeholder: 'Street number and name',
    address2_placeholder: 'Complement (optional)',
    postal_placeholder: '75001',
    title_contact: 'Title',
    role: 'Role / Position',
    first_name: 'First name',
    last_name: 'Last name *',
    email: 'Email',
    phone: 'Phone',
    comm_recipient: 'Communication recipient',
    main_contact: 'Main contact',
    add_contact: '+ Add contact',
    remunerated: 'Is the intermediary remunerated?',
    remunerated_desc: 'If yes, a commission rate will be applied to all linked policies.',
    commission_rate: 'Commission rate *',
    commission_auto: 'The commission will be applied automatically to all linked policies.',
    not_remunerated_info: 'No commission will be generated for this intermediary.',
    suspension_date: 'Suspension date',
  },

  clients: {
    title: 'Client Management',
    create_btn: '+ Create client',
    search_placeholder: 'Search by name, activity, country…',
    count: 'client',
    count_plural: 'clients',
    col_name: 'NAME / COMPANY',
    col_activity: 'MAIN ACTIVITY',
    col_relation: 'DISTRIBUTION',
    col_country: 'COUNTRY',
    col_status: 'STATUS',
    col_actions: 'ACTIONS',
    via: 'via',
    new_title: 'New client',
    edit_title: 'Edit client',
    breadcrumb: 'Clients',
    tab_relation: 'Relationship',
    tab_company: 'Company',
    tab_contacts: 'Contacts',
    tab_activities: 'Activities',
    client_status: 'Client status',
    client_status_desc: 'Determines the tracking level and available actions.',
    market: 'Market *',
    market_placeholder: '— Select a country —',
    relation_type: 'Distribution type *',
    direct: 'Direct',
    brokered: 'Brokered',
    broker_label: 'Broker *',
    broker_placeholder: '— Select a broker —',
    broker_auto_commission: "The broker's commission rate will be applied automatically to all policies.",
    third_party: 'THIRD PARTY',
    third_party_desc: 'Select if a third party is involved (lawyer, association, other). Multiple selections allowed.',
    company_name: 'Company name *',
    company_placeholder: 'e.g. World Travels Ltd',
    legal_status: 'Legal status',
    registration: 'Registration number',
    registration_placeholder: 'e.g. 892 345 678',
    unlock_btn: 'Unlock',
    unlock_confirm: 'Reset this document to pending validation?',
    doc_gf_cert_immat: 'Registration certificate',
    doc_gf_statuts: 'Company articles of association',
    doc_gf_cv_dirigeant: "Director's CV",
    doc_gf_piece_id: "Director's identity document",
    doc_gf_presentation_projet: 'Project presentation',
    doc_gf_previsionnel: 'Detailed business forecast',
    doc_gf_cgv: 'General terms and conditions of sale',
    doc_gf_presentation_activites: 'Activity presentation',
    doc_gf_previsionnel_annuel: 'Business forecast for the guaranteed year',
    doc_gf_bilan_cr: 'Latest detailed balance sheet and P&L',
    doc_gf_attestation_rcpro: 'Current PI insurance certificate',
    doc_gf_attestation_fonds: 'Held funds peak certificate',
    readonly_banner: 'Read-only view — upload and preview only',
    broker_readonly: 'As a broker, you can only view client records.',
    address_siege: 'Registered address',
    broker_status_locked: 'Prospect — status defined by Arcus underwriter',
    accepted_label: 'accepted',
    required_label: 'Required',
    delete_btn: '🗑 Delete',
    doc_contrat_reservation: 'Copy of the booking contract with the agency',
    doc_preuve_paiement: 'Proof of payment(s)',
    doc_bon_voucher: 'Unused voucher (if applicable)',
    delete_confirm: 'This client has active policies. Delete them first.',
    contacts_section: 'Contacts',
    main_contact: 'Main contact',
    contact_number: 'Contact',
    add_contact: '+ Add contact',
    title_contact: 'Title',
    role: 'Role / Position',
    first_name: 'First name',
    last_name: 'Last name *',
    email: 'Email',
    phone: 'Phone',
    comm_recipient: 'Communication recipient',
    activities_section: 'Activities',
    principal_activity: 'Main activity',
    principal_activity_desc: 'Primary activity of the agency (single selection)',
    secondary_activities: 'Secondary activities',
    secondary_activities_desc: 'Other activities carried out (multiple selection)',
    no_activity_selected: 'Please select a main activity first',
  },

  client_detail: {
    modify_fiche: 'Edit record',
    legal_status: 'Legal status',
    registration: 'Registration n°',
    market: 'Market',
    distribution: 'Distribution',
    direct_distribution: 'Direct (+15% Arcus)',
    brokered_distribution: 'Brokered',
    address_label: '📍',
    policies_title: 'Insurance policies',
    contract_count: 'contract',
    contract_count_plural: 'contracts',
    create_policy: '+ New PI policy',
    no_policies: 'No policy for this client. Click "New RC Pro policy" to create a quote.',
    col_piece: 'REFERENCE',
    col_status: 'STATUS',
    col_premium: 'GROSS PREMIUM',
    col_effect: 'EFFECTIVE DATE',
    col_expiry: 'EXPIRY',
    col_actions: 'ACTIONS',
    renew: '🔄 Renew',
    terminate: 'Terminate',
    amendment_prefix: 'Amendment n°',
    new_amendment: '✎ New amendment',
    expiry_warning: '⚠',
    renewal_line: "Renewed on",
    collapse: "Collapse",
    expand: "Expand",
    previous_period: "Previous period",
  },

  polices: {
    title: 'Professional Liability',
    breadcrumb: 'Policies',
    portfolio_title: 'PI Portfolio',
    create_from_client: 'Policies are created from the client record',
    col_client: 'CLIENT / POLICY N°',
    col_country: 'COUNTRY',
    col_premium: 'GROSS PREMIUM',
    col_expiry: 'EXPIRY',
    col_status: 'STATUS',
    tab_policy: 'The policy',
    tab_tarification_gf: 'Underwriting',
    tarif_add_period: '+ Add period',
    tarif_period: 'Period',
    tarif_date_debut: 'Start date',
    tarif_date_fin: 'End date',
    tarif_exposition: 'Exposure (€)',
    tarif_taux: 'Rate (%)',
    tarif_prime_ht: 'Net premium',
    tarif_taxe: 'Tax (9%)',
    tarif_prime_ttc: 'Gross premium',
    tarif_total: 'TOTAL GROSS PREMIUM',
    tarif_hint: 'Net premium = Exposure × Rate · Tax = 9% · Gross premium = Net + Tax',
    tab_underwriting: 'Information Collection',
    tab_tarification: 'Underwriting',
    tab_documents: 'Documents',
    client_readonly: 'Client — read only',
    risk_insured_title: 'Is the risk already insured elsewhere?',
    risk_insured_yes: 'Transfer from another insurer — loss history required',
    risk_insured_no: 'New business',
    current_insurer: 'Current insurer *',
    policy_status: 'Policy status',
    quote_number: 'Quote number',
    policy_number: 'Policy number',
    policy_number_required: 'Required before moving to Bound',
    effect_date: 'Effective date *',
    expiry_date: 'Expiry date',
    expiry_auto: '(auto +1 year)',
    renewal_note: '🔄 Renewal by annual tacit agreement.',
    locked_banner: 'Bound policy (view only)',
    renewal_banner: '🔄 Renewal — period',
    to: 'to',
    create_amendment: '✎ Create amendment',
    renew_btn: '🔄 Renew',
    terminate_btn: 'Terminate',
    move_to_bound: 'Move to Bound',
    confirm_binding_title: '⚠ Confirm binding',
    confirm_binding_desc: 'You are about to bind this policy.',
    confirm_binding_warning: 'All fields will be locked.',
    renewal_title: '🔄 Create a renewal',
    renewal_question: 'Do you want to renew this policy on the same terms as the',
    renewal_last_active: 'last active version',
    renewal_same: '✓ Yes — same terms',
    renewal_same_desc: 'All current values are carried over. Dates updated automatically.',
    renewal_new: '✎ No — new terms',
    renewal_new_desc: 'The form opens pre-filled. You enter the new turnover.',
    declared_ca: 'Declared annual turnover (€) *',
    payment_freq: 'Payment frequency',
    loading_factors: "Questions about activities",
    discount_factors: 'Discount factors',
    covered_activities: "Activities carried out",
    special_conditions: 'Special conditions',
    special_conditions_hint: 'If empty → "None" in the document.',
    special_conditions_placeholder: 'Specific clause to include in the contract…',
    loss_history: 'Loss history',
    loss_takeover: 'Transfer · Current insurer',
    loss_closed: 'Closed claims (> €1,500)',
    loss_open: 'Open claims (> €1,500)',
    loss_total_paid: 'Total paid (€)',
    loss_count: 'Count',
    loss_provision: 'Reserved (€)',
    loss_partial: 'Part. paid (€)',
    loss_years: 'Years on statement',
    net_premium: 'Net premium',
    commission: 'Commission',
    tax: 'Tax',
    gross_premium: 'Gross premium',
    above_ceiling: '⚠ Turnover > €10M — submit directly to the insurer.',
    enter_ca: 'Enter a turnover to display the premium calculation.',
    floor_applied: '· Floor €600 applied',
    global_coeff: 'Global coefficient',
    freq_annual: 'Annual (+0%)',
    freq_semi: 'Semi-annual (+2%)',
    freq_quarter: 'Quarterly (+4%)',
    freq_month: 'Monthly (+6%)',
    internal_notes: 'Internal notes',
    notes_placeholder: 'Underwriting notes, special conditions…',
    maj_q1: 'More than 50% of turnover linked to sports travel, weddings, stag/hen parties?',
    maj_q2: 'Over 50% of passengers / turnover to countries outside EU, Scandinavia, Switzerland, AUS, NZ?',
    maj_q3: 'USA / Canada coverage extension?',
    maj_q4: 'Group travel of more than 10 people?',
    maj_q5: 'Over 50% of stays include non-standard transfers (4×4, boat, plane)?',
    maj_q6: 'Over 50% of stays include high-risk activities (skiing, diving, parachuting…)?',
    min_q1: 'Clean loss record over the past 48 months?',
    min_q2: 'Director with 10+ years of experience in travel agencies or tour operators?',
    act1: 'Ticketing',
    act2: 'Organisation of stays or trips in France or abroad',
    act3: 'Sale of package holidays organised by a Tour Operator',
    act4: 'Incoming tourism',
    act5: 'Commission-based sales (hotel, car rental, assistance, theatre…)',
    doc_language: '🌐 Language: French · French law applicable',
    doc_devis_warning: '⚠ Status Quote — Policy and certificate available after binding.',
    doc_locked_docs: 'Contract documents',
    doc_project: 'Insurance quote',
    doc_project_desc: 'Quote presentation document',
    doc_policy: 'Policy schedule',
    doc_cg: 'General conditions',
    doc_attestation: 'Insurance certificate',
    doc_attestation_desc: 'PI coverage certificate',
    direct_plus15: 'Direct · +15% Arcus',
    brokered_comm: 'Brokered · % broker',
    broker_view_banner: 'Broker view — view and document upload only',
    broker_docs_locked: '🔒 Available after binding',
    confirm_binding_docs_missing: 'Required documents not validated — binding not allowed',
    doc_waiting_approval: 'Uploaded but awaiting approval',
    doc_not_uploaded: 'Not uploaded',
    docs_in_french: 'Documents in French',
    warn_date_effet_locked: "Modification possible but sensitive — check impact on amendments and any pending renewal",
    // ── Workflow étude/souscription RC Pro ──
    etude_title: "File review",
    etude_locked_note: "Section locked — the policy is bound.",
    numero_projet: "Project number",
    date_effet_prev: "Provisional effective date",
    rcpro_step_devis: "Quote (awaiting documents)",
    rcpro_step_devis_hint: "The broker/client completes the file and submits it to Arcus.",
    rcpro_step_etude_hint: "Reached when the broker/client submits the subscription request.",
    repasser_devis_btn: "Revert to Quote",
    repasser_devis_confirm_title: "Revert the file to Quote?",
    repasser_devis_confirm_desc: "The form becomes editable again by the broker/client; data already entered is kept. The file returns to the “Quote (awaiting documents)” status.",
    repasser_devis_confirm_btn: "Revert to Quote",
    police_locked_note: "Section activated when the policy is bound.",
    souscrire_btn: "Bind the policy",
    souscrire_need_date: "Enter the effective date.",
    souscrire_need_npolice: "Enter the policy number.",
    souscrire_confirm_title: "Bind the policy",
    souscrire_confirm_desc: "Confirm the details below to create the policy. The “Policy” section will be activated and the review locked.",
    souscrire_date_label: "Policy effective date",
    souscrire_npolice_label: "Policy number",
    souscrire_confirm_btn: "Bind",
    // ── RC Pro : onglet Souscription + mention spéciale ──
    ajustement_title: "Rate adjustment",
    ajustement_hint: "Voluntary premium increase (cannot lower it).",
    ajustement_coeff: "Coefficient (e.g. 1.25 = +25%)",
    ajustement_min_note: "Minimum 1.00 (no decrease)",
    discount_hint: "Check to apply the discount to the current quote.",
    dossier_decline_banner: "File declined — the risk was refused by Arcus.",
    dossier_decline_status: "File declined",
    exclusion_title: "\"Festive\" exclusion",
    exclusion_remove_label: "Remove the exclusion",
    exclusion_text: "Organising, selling or reselling festive trips/stays such as stag/hen parties, spring break, student-union trips…",
    exclusion_present_note: "The exclusion appears in the insurance proposal.",
    exclusion_removed_note: "The exclusion is removed and will not appear in the insurance proposal.",
    mention_approve: "Approve",
    mention_approved: "Mention approved by Arcus.",
    mention_client_request: "Client / broker request",
    mention_none: "No special-mention request.",
    mention_pending: "Request sent to Arcus Solutions — awaiting processing.",
    mention_reformulate: "Reformulate",
    mention_reformulate_confirm: "Confirm reformulation",
    mention_reformulate_empty: "Enter the reformulation.",
    mention_reformulate_label: "Mention reformulation",
    mention_reformulated: "Mention reformulated by Arcus.",
    mention_refuse: "Refuse the risk",
    mention_refused: "Risk refused — file declined.",
    mention_submit_btn: "Submit the request to Arcus Solutions",
    mention_submit_confirm_title: "Submit the request to Arcus?",
    mention_submit_confirm_desc: "Your request will be sent to Arcus Solutions for review. The file will be locked and no document can be downloaded until Arcus decides.",
    mention_submit_confirm_btn: "Submit the request",
    tab_souscription: "Underwriting",
  },

  resiliation: {
    title: 'Terminate policy',
    title_amendment: 'Terminate amendment',
    motif_label: 'Reason for termination *',
    motif_echeance: 'Termination at expiry',
    motif_echeance_desc: 'Policy terminated on the expiry date.',
    motif_disparition: 'Risk ceases to exist',
    motif_disparition_desc: 'Termination date required. Pro-rata calculated automatically.',
    motif_aggravation: 'Material change in risk',
    motif_aggravation_desc: 'Notification date required. Termination 10 days after. Pro-rata calculated.',
    motif_nonpaiement: 'Non-payment',
    motif_nonpaiement_desc: 'Termination date required. No premium refund.',
    notif_date: 'Notification date *',
    resil_date: 'Termination date *',
    j_plus_10: '(D+10)',
    prorata_title: 'Pro-rata temporis',
    prorata_total: 'Total period',
    prorata_remaining: 'Remaining days',
    prorata_refund: 'Amount to refund',
    prorata_days: 'days',
    note_label: 'Internal note',
    note_placeholder: 'Reason for termination…',
    confirm_btn: '✓ Confirm termination',
  },

  amendements: {
    tab_amendment: 'The amendment',
    tab_tarification_gf: 'Underwriting',
    tarif_add_period: '+ Add period',
    tarif_period: 'Period',
    tarif_date_debut: 'Start date',
    tarif_date_fin: 'End date',
    tarif_exposition: 'Exposure (€)',
    tarif_taux: 'Rate (%)',
    tarif_prime_ht: 'Net premium',
    tarif_taxe: 'Tax (9%)',
    tarif_prime_ttc: 'Gross premium',
    tarif_total: 'TOTAL GROSS PREMIUM',
    tarif_hint: 'Net premium = Exposure × Rate · Tax = 9% · Gross premium = Net + Tax',
    tab_underwriting: 'Information Collection',
    tab_documents: 'Documents',
    replaced_contract: 'Superseded contract',
    current_policy: 'Policy n°',
    current_premium: 'Current gross premium',
    client: 'Client',
    effect_date: 'Amendment effective date *',
    effect_date_hint: 'Free input — can be backdated or future-dated.',
    notes_label: 'Internal notes (reason for amendment)',
    notes_placeholder: 'e.g.: Change of activity, increase in declared turnover…',
    comparison_title: '⇄ Comparison with current contract',
    current_contract: 'Current contract',
    amendment_label: 'Amendment',
    difference: 'Difference',
    increase_msg: '↑ Increase · Additional premium invoice',
    decrease_msg: '↓ Decrease · 0€ regularisation — no additional premium',
    stable_msg: '= Premium unchanged — amendment with no financial impact',
    activate_btn: 'Activate',
    activate_disabled: 'Effective date required to activate',
    confirm_activate_title: '⚠ Confirm activation',
    confirm_activate_desc: 'will supersede the current contract.',
    confirm_activate_irreversible: 'The original contract will be archived.',
    locked_banner: '🔒 Active amendment — fields locked (view only).',
    doc_project: 'Amendment draft',
    doc_project_desc: 'Presentation document',
    doc_project_warning: "⚠ Status Draft — Contract documents unlock after activation.",
    doc_section_project: 'Draft documents',
    doc_section_contracts: 'Contract documents',
    doc_appel_section: 'Additional premium / Regularisation',
    doc_appel_title: 'Additional premium invoice',
    doc_appel_amount: 'Amount',
    doc_regularisation: 'Regularisation letter',
    doc_regularisation_desc: '0€ regularisation — no additional premium',
    delete_title: 'Delete amendment',
    unlock_btn: 'Unlock',
    unlock_confirm: 'Reset this document to pending validation?',
    doc_gf_cert_immat: 'Registration certificate',
    doc_gf_statuts: 'Company articles of association',
    doc_gf_cv_dirigeant: "Director's CV",
    doc_gf_piece_id: "Director's identity document",
    doc_gf_presentation_projet: 'Project presentation',
    doc_gf_previsionnel: 'Detailed business forecast',
    doc_gf_cgv: 'General terms and conditions of sale',
    doc_gf_presentation_activites: 'Activity presentation',
    doc_gf_previsionnel_annuel: 'Business forecast for the guaranteed year',
    doc_gf_bilan_cr: 'Latest detailed balance sheet and P&L',
    doc_gf_attestation_rcpro: 'Current PI insurance certificate',
    doc_gf_attestation_fonds: 'Held funds peak certificate',
    readonly_banner: 'Read-only view — upload and preview only',
    broker_readonly: 'As a broker, you can only view client records.',
    address_siege: 'Registered address',
    broker_status_locked: 'Prospect — status defined by Arcus underwriter',
    accepted_label: 'accepted',
    required_label: 'Required',
    delete_btn: '🗑 Delete',
    doc_contrat_reservation: 'Copy of the booking contract with the agency',
    doc_preuve_paiement: 'Proof of payment(s)',
    doc_bon_voucher: 'Unused voucher (if applicable)',
    delete_confirm: 'Are you sure you want to delete amendment',
    resiliation_info_title: 'Terminated amendment',
    resiliation_motif: 'Reason',
    resiliation_date: 'Date',
    resiliation_prorata: 'Pro-rata',
    new_amendment: '✎ New amendment',
  },

  documents: {
    cp: 'Schedule',
    attestation: 'Certificate',
    cg: 'Gen. conditions',
    policy: 'Policy schedule',
    general_conditions: 'General conditions',
    certificate: 'Insurance certificate',
    quote: 'Insurance quote',
  },

  auth: {
    forgot_password: "Forgot password?",
    forgot_title: "Forgot password",
    forgot_desc: "Enter your email, we will send you a link to set a new password.",
    forgot_btn: "Send link",
    forgot_sent: "If an account exists with this email, a reset link has just been sent.",
    back_to_login: "Back to login",
    reset_title: "New password",
    reset_desc: "Choose a secure password (8 characters minimum).",
    reset_btn: "Set password",
    reset_success: "Password set. You can now log in.",
    redirecting: "Redirecting to login…",
    password_mismatch: "Passwords do not match.",
    password_too_short: "Minimum 8 characters.",
    email_required: "Email is required.",
    welcome: 'Welcome',
    sign_in_desc: 'Sign in to your ARCUSCONNECT workspace',
    email: 'Email address',
    email_placeholder: 'your@email.com',
    password: 'Password',
    password_placeholder: '••••••••',
    sign_in: 'Sign in',
    signing_in: 'Signing in…',
    logout: 'Sign out',
    fill_all: 'Please fill in all fields',
    access_levels: 'Access levels',
    change_password: 'Change password',
    current_password: 'Current password',
    new_password: 'New password',
    confirm_password: 'Confirm password',
    password_changed: 'Password changed successfully',
  },
  sinistres: {
    title: 'Claims Management',
    subtitle: 'Compensation procedures following financial failure of travel agencies',
    open_procedure: 'Open a procedure',
    filter_all: 'All', col_numero: 'Procedure n°', col_agence: 'Travel agency',
    col_statut: 'Status', col_date_ouv: 'Opening date',
    col_date_fin: 'End of compensation', col_actions: 'Actions',
    no_procedures: 'No claims procedure recorded.',
    open_btn: 'Open', loading: 'Loading…',
    modal_title: 'Open a procedure',
    modal_subtitle: 'Select the failing agency and define the procedure dates.',
    select_agence: '— Select an agency —',
    date_ouverture: 'Opening date *', date_fin: 'End of compensation date',
    notes: 'Internal notes (optional)', notes_placeholder: 'Context, useful information…',
    valider: 'Submit →', creation: 'Creating…',
    confirm_title: 'Confirmation required', confirm_subtitle: 'Irreversible action — Manager only',
    confirm_about: 'You are about to officially open the claims procedure for:',
    confirm_warning: '⚠ This action will permanently lock the agency and cannot be undone.',
    confirm_no_manager: 'Only a Manager account can confirm this opening.',
    annuler_procedure: '✕ Cancel procedure',
    confirmer_ouverture: '✓ Confirm opening', confirmation_loading: 'Confirming…',
    agence_locked: 'Agency locked', procedure_label: 'Claims procedure',
    cloturer: 'Close procedure', infos_procedure: 'Procedure information',
    modifier: '✎ Edit', tracabilite: 'Audit trail',
    cree: 'Procedure created', confirmee: 'Procedure confirmed and opened',
    cloturee_label: 'Procedure closed', par: 'by',
    cloturer_confirm_title: 'Close the procedure?',
    cloturer_confirm_body: 'The procedure will be marked as closed. This action cannot be undone.',
    cloturer_btn: 'Close', pending_alert: 'Awaiting Manager confirmation',
    pending_desc: 'This procedure has been created but is not yet officially open.',
    statut_ouverture_pendante: 'Awaiting confirmation',
    statut_ouverte: 'Procedure open', statut_cloturee: 'Closed',
    dossiers_title: 'Compensation files',
    ajouter_dossier: '+ Add a file',
    no_dossiers: 'No file recorded. Click "+ Add a file" to get started.',
    pending_dossiers: 'The procedure must be confirmed by a Manager before files can be added.',
    col_souhait: 'Wish',
    col_montant_total: 'Trip amount',
    col_acompte: 'Deposit paid',
    col_solde: 'Balance due',
    col_numero_dossier: 'File n°', col_voyageur: 'Beneficiary', col_type: 'Type',
    nouveau_dossier: 'New file',
    nouveau_dossier_subtitle: 'Register a new beneficiary of the financial guarantee.',
    type_beneficiaire: 'Beneficiary type',
    particulier: '👤 Individual', professionnel: '🏢 Professional',
    nom_particulier: 'Last name / First name *', nom_professionnel: 'Company name *',
    creer_dossier: 'Create file →', creation_dossier: 'Creating…',
    statut_dossier: 'File status', reserved_manager: 'Manager only',
    validation_required: 'Manager validation required',
    validation_desc: 'This file is ready for final validation before payment.',
    decliner: '✕ Decline', valider_paiement: '✓ Approve payment',
    pieces_title: 'Supporting documents',
    pieces_desc: 'Upload and validate beneficiary documents',
    finances_title: 'Financial data',
    finances_desc: 'Trip amount, deposits paid, compensation due',
    banque_title: 'Banking information',
    banque_desc: 'IBAN, account holder, bank institution',
    a_developper: 'To be developed',
    voyageur_info: 'Beneficiary information',
    benef_intro: 'Please answer the following questions.',
    submit_blocked_hint: 'Complete the required information and provide all documents before submitting.',
    submit_missing_title: 'To submit your file, you still need to complete:',
    submit_missing_fields: 'Missing required information:',
    submit_missing_pieces: 'Supporting documents to provide:',
    piece_label_generic: 'Supporting document',
    passer_en_cours: 'Move to processing',
    passer_en_cours_title: 'Move the case to processing?',
    passer_en_cours_desc: 'The case will move to “Processing” status, allowing you to continue handling it without waiting for the traveller to submit. Remember to save your changes first.',
    benef_date_depart: 'Trip departure date',
    benef_carte_warning: 'Please file a refund request or a claim under Section 75. If your issuing bank or credit card provider has refused your request, please provide proof or acknowledgement of that refusal as part of your claim file.',
    benef_voyageurs_label: 'Travellers concerned',
    benef_add_voyageur: 'Add a traveller',
    benef_voyageurs_groupe: 'If this is a group of more than 10 people, please provide the list of travellers along with the supporting documents in the next section.',
    voyageur_titre: 'Title',
    voyageur_nom: 'Last name',
    voyageur_prenom: 'First name',
    voyageur_email: 'Email address',
    voyageur_telephone: 'Phone',
    voyageur_titre_m: 'Mr',
    voyageur_titre_mme: 'Mrs / Ms',
    voyageur_titre_mmme: 'Mr & Mrs',
    voyageur_titre_ste: 'Company',
    voyageur_titre_asso: 'Association',
    voyage_info: 'Travel information',
    voyage_intro: 'Please check the information provided by the declarant and fill in the remaining fields using the travel documents. If necessary, correct the Travel information section.',
    voyage_montant_total: 'Total trip amount (€)',
    voyage_acompte: 'Deposit paid (€)',
    voyage_solde: 'Outstanding balance (€)',
    voyage_solde_auto: 'Auto-calculated: Total amount − Deposit',
    voyage_appel_fonds: 'Generate payment request',
    voyage_appel_fonds_title: 'Payment request',
    voyage_appel_fonds_soon: 'The payment request template is being prepared.',
    voyage_appel_fonds_preview: 'Preview — for information only',
    voyage_appel_fonds_email: 'Send by email',
    voyage_appel_fonds_copy: 'Copy',
    voyage_appel_fonds_copied: 'Copied!',
    souhait_label: 'Traveller wish',
    souhait_remboursement: 'Refund',
    souhait_maintien: 'Trip continuation',
    souhait_rapatriement: 'Repatriation',
    paiement_title: 'Payment management',
    paiement_type: 'Recipient type',
    paiement_nom: 'Last name',
    paiement_prenom: 'First name',
    paiement_adresse: 'Address',
    paiement_cp: 'Postal code',
    paiement_ville: 'City',
    paiement_iban: 'IBAN',
    paiement_swift: 'SWIFT / BIC code',
    paiement_reference: 'Payment reference',
    paiement_ref_auto: 'Auto-generated',
    paiement_montant: 'Amount to pay (€)',
    paiement_ajouter: '+ Add a payment',
    paiement_numero: 'Payment n°',
    paiement_aucun: 'No payment recorded.',
    paiement_particulier: 'Individual',
    paiement_professionnel: 'Professional',
    supprimer_dossier: 'Delete file',
    supprimer_dossier_confirm: 'Are you sure you want to delete this file? This action is irreversible.',
    dossiers_count: '{n} file recorded',
    dossiers_count_pl: '{n} files recorded',
    type_particulier: '👤 Individual',
    type_professionnel: '🏢 Professional',
    dos_statut_en_attente_informations: 'Awaiting information',
    dos_statut_en_cours_traitement: 'Processing',
    dos_statut_attente_validation: 'Pending validation',
    dos_statut_attente_paiement_solde: 'Awaiting balance payment',
    dos_statut_solde_paye: 'Balance paid',
    dos_statut_attente_paiement_compta: 'Awaiting accounting payment',
    dos_statut_paiement_realise: 'Payment completed',
    dos_statut_decline: 'Declined',
statut_auto_info: 'The status changes automatically based on actions taken on the file.',
    date_limite_paiement: 'Payment deadline',
    appel_fonds_pdf: 'Generate Payment Request PDF',
    appel_fonds_email_pdf: 'Send by email',
    appel_fonds_dl: 'Downloading…',
    benef_montant_facture: 'Total amount billed to you (€)',
    benef_type_reglement: 'Did you pay a deposit or full payment?',
    benef_type_acompte: 'Deposit',
    benef_type_totalite: 'Full payment',
    benef_montant_acompte: 'Amount of deposit (€)',
    benef_modes_paiement: 'How did you pay?',
    benef_mode_carte: 'Credit/debit card',
    benef_mode_virement: 'Bank transfer',
    benef_mode_cheque: 'Cheque',
    benef_mode_especes: 'Cash',
    benef_mode_cadeau: 'Gift voucher / Credit / Wedding list',
    benef_nb_voyageurs: 'Number of travellers concerned',
    benef_souhait_client: 'What do you wish?',
    benef_souhait_remboursement: 'Get a refund',
    benef_souhait_maintien: 'Continue my trip',
    benef_souhait_rapatriement: 'Be repatriated',
    docs_admin_title: 'Documents',
    docs_admin_generer_pdf: 'Generate Payment Request PDF',
    docs_admin_pdf_saved: 'PDF generated and saved',
    docs_admin_ajouter: '+ Add a document',
    docs_admin_nom_label: 'Document name',
    docs_admin_aucun: 'No document recorded.',
    docs_admin_appel_fonds: 'Payment request',
    creer_acces_voyageur: "Create traveller access",
    creer_acces_subtitle: "Create an account to allow the traveller to complete their file online.",
    acces_email: "Traveller email",
    acces_password: "Temporary password",
    acces_generer: "Generate access",
    acces_cree: "Access created — send credentials to traveller",
    voyageur_space: "My claims space",
    voyageur_mon_dossier: "My file",
    err_required: "Agency and opening date are required",
    warning_manager: "The validation must be confirmed by a Manager before the procedure is officially opened. This confirmation will permanently lock the affected agency.",
  },

  collecte: {
    title: 'Risk Declaration — Financial Guarantee',
    dr_ref: 'Reference: DR-V-2401 · arcus-solutions.fr',
    section_renseignements: 'General information',
    nom_social: 'Company name *',
    nom_commercial: 'Trading name (if different)',
    directeur: 'Director / Manager',
    adresse: 'Address',
    forme_juridique: 'Legal form',
    capital_social: 'Share capital',
    siren: 'SIREN number',
    site_internet: 'Website',
    date_creation: 'Date of incorporation',
    date_cloture: 'Financial year-end date',
    nb_agences: 'Number of agencies',
    nb_collaborateurs: 'Number of employees',
    immat_atout_france: 'Atout France registration n°',
    rc_pro_numero: 'Professional liability insurance n°',
    rc_pro_compagnie: 'Insurance company name',
    rc_pro_echeance: 'PI insurance expiry',
    banque_title: 'Main bank',
    ec_title: 'Chartered accountant',
    correspondant: 'Contact person',
    section_dirigeants: 'Directors',
    dir_nom: 'Name *',
    dir_formations: 'Professional training',
    dir_annees: 'Years of experience (tourism)',
    dir_pct: '% of share capital',
    dir_situations: 'Has the director / shareholder been in any of these situations?',
    dir_sauvegarde: 'Safeguard procedure',
    dir_redressement: 'Court-supervised restructuring',
    dir_liquidation: 'Compulsory liquidation',
    dir_infos: 'Important information you wish to share',
    dir_add: '+ Add director / shareholder',
    dir_del: 'Remove',
    dir_num: 'Director / Shareholder',
    section_patrimoine: 'Directors\'s assets',
    pat_nom: 'Director name',
    pat_estimation: 'Estimated value (€)',
    pat_type_immo: 'Real estate asset type',
    pat_adresse_immo: 'Property address',
    pat_type_mobilier: 'Personal asset type',
    pat_prets: 'Outstanding loans (€)',
    pat_etablissement: 'Subscribing institution',
    pat_capital: 'Capital invested (€)',
    pat_add: '+ Add director asset',
    section_societes: 'Other companies of shareholders',
    soc_warning: 'Please fill in this table and attach the latest accounts for each entity. If there is a history of insolvency, please indicate it.',
    soc_nom: 'Company name',
    soc_associe: 'Related shareholder',
    soc_date: 'Incorporation date',
    soc_ca: 'Revenue (Y-1) €',
    soc_resultat: 'Net result (Y-1) €',
    soc_add: '+ Add company',
    section_presentation: 'Brief description of your activity / project',
    description_label: 'Describe your activity / project *',
    description_placeholder: 'Description of the activity or business creation project…',
    reseau_label: 'Are you / will you be joining a network? If yes, which one?',
    reseau_placeholder: 'e.g. Selectour, Afat, Thomas Cook…',
    ca_title: 'Revenue breakdown (€)',
    ca_forfaits_dist: 'Package holidays — Distribution (€)',
    ca_forfaits_prod: 'Package holidays — Production (€)',
    ca_prestations: 'Standalone tourist services (€)',
    ca_transport: 'Standalone transport (€)',
    ca_total: 'TOTAL Revenue (€)',
    clientele_btoc: 'BtoC clients (Individuals / Companies / Works Councils)',
    clientele_btob: 'BtoB clients (other travel professionals)',
    clientele_autres: 'Other clients',
    mode_distrib: 'Distribution channels (website, agency, network…)',
    fournisseurs_label: 'Main suppliers (TOs, ground handlers, hotels, DMCs…)',
    fournisseurs_placeholder: 'e.g. Jet tours, Kuoni, Accor…',
    section_complement: 'Additional information',
    engagement_label: 'Volume commitments with suppliers? Detail if yes',
    delais_label: 'Supplier payment terms / deadlines',
    repartition_monde: 'Worldwide activity breakdown (%)',
    reglement_title: 'Client payment methods (%)',
    reglement_especes: 'Cash %',
    reglement_cheque: 'Cheque %',
    reglement_virement: 'Bank transfer / Direct debit %',
    reglement_carte: 'Card %',
    passerelle_label: 'Do you use a payment gateway (merchant acquirer)?',
    passerelle_nom: 'If yes, which one',
    passerelle_delai: 'Fund transfer delay (days)',
    section_previsionnel: 'Financial forecast',
    pct_acompte: '% deposit collected at booking',
    mois_reservation: 'On average, how many months in advance do clients book?',
    mois_solde: 'How many months before departure is the balance paid?',
    montant_moyen: 'Average spend per traveller (€)',
    previsionnel_title: 'Revenue forecast by departure date — guaranteed period',
    previsionnel_desc: 'Take into account only the Revenue relating to services provided. Example: A group of 10 people departing in July, Revenue is €10,000, please indicate €10,000 in July.',
    previsionnel_col1: 'Month / Year',
    previsionnel_col2: 'Declared services (€)',
    previsionnel_total: 'TOTAL',
    previsionnel_hint: 'Enter the 1st month — the following 11 months fill in automatically',
  },

    rcpro_studies: {
    title: "RC Pro subscription requests under review",
  },
  gf_studies: {
    title: "Files under review",
    count: "file",
    count_plural: "files",
    empty: "No files under review.",
    col_client: "Client",
    col_broker: "Broker",
    col_submitter: "Submitted by",
    col_date: "Submitted on",
    col_actions: "Actions",
    study_btn: "Review file",
  },
  gf_declarations: {
    title: "Turnover declarations",
    count: "file",
    count_plural: "files",
    empty: "No pending declaration.",
    col_client: "Client",
    col_broker: "Broker",
    col_period: "Declared period",
    col_declared: "Declared on",
    col_amount: "Actual / Forecast",
    col_actions: "Actions",
    review_btn: "Review",
    over_forecast: "Above forecast",
    vs_prev: "forecast",
  },
  gf_requests: {
    title: "Financial guarantee opening requests",
    count: "request",
    count_plural: "requests",
    empty: "No pending opening requests.",
    col_client: "Client",
    col_broker: "Broker",
    col_requester: "Requester",
    col_date: "Requested on",
    col_actions: "Actions",
    validate: "Approve",
    refuse: "Decline",
    refuse_title: "Decline the request",
    refuse_desc: "Provide the reason for declining",
    refuse_motif_ph: "Reason for declining (optional)",
    refuse_confirm: "Confirm decline",
  },
  rcpro: {
    submit_btn: "Submit subscription request",
    submit_blocked_hint: "Upload all required subscription documents to submit.",
    submit_missing_title: "To submit your subscription request, you still need:",
    submit_missing_docs: "Subscription documents to upload.",
    submitted_banner: "Subscription request submitted to Arcus Solutions — under review. The form is locked during review.",
    submit_confirm_title: "Submit the subscription request?",
    submit_confirm_desc: "Your request (subscription documents) will be sent to the Arcus Solutions team for review. The form will be locked during the review. You will be informed of the outcome.",
    submit_confirm_btn: "Submit",
  },
  notes_int: {
    open: "Internal discussion",
    title: "Internal discussion",
    scope_client: "Thread linked to this client",
    scope_police: "Thread linked to this contract",
    empty: "No internal notes yet. Add a comment to start this file's history.",
    placeholder: "Add an internal comment…",
    attach: "Attach files",
    drop_here: "Drop files here",
    hint: "Drag & drop a file or email · Ctrl+Enter to send",
    readonly: "View only for this profile.",
    delete_confirm: "Delete this comment?",
  },
  gf: { submit_btn: "Submit file to Arcus", submit_blocked_hint: "Complete the collection form and upload all required documents to submit.", submit_missing_title: "To submit your file to Arcus Solutions, you still need to complete:", submit_missing_collecte: "Missing required information (Information collection):", submit_missing_docs: "Subscription documents to upload.", submitted_banner: "File submitted to Arcus Solutions — under review. The form is locked during review.", submit_confirm_title: "Submit the file to Arcus Solutions?", submit_confirm_desc: "Your file (collection + documents) will be sent to the Arcus Solutions team for review. The form will be locked during the review. You will be informed of the outcome.", submit_confirm_btn: "Submit", request_open_btn: "Request a financial guarantee file opening", request_done_msg: "Your file opening request has been sent to the Arcus Solutions team, who will get back to you for its review as soon as possible.", awaiting_validation: "Awaiting validation",
    tab_surveillance: "Risk monitoring",
    surveillance_intro_title: "Monitoring of actual revenue",
    surveillance_intro_text: "At regular intervals, the client declares actual revenue achieved to verify consistency with the forecast. This data feeds the financial guarantee monitoring.",
    surveillance_frequency_label: "Monitoring frequency",
    surveillance_freq_trim: "Quarterly",
    surveillance_freq_sem: "Semi-annually",
    surveillance_freq_not_set: "Not set",
    surveillance_pick_freq: "Select the monitoring frequency to generate the declaration periods.",
    surveillance_not_subscribed: "Declaration periods will be generated once the policy is bound.",
    surveillance_period: "Period",
    surveillance_declaration_in: "Declaration expected in",
    surveillance_col_month: "Month",
    surveillance_col_previsionnel: "Forecast",
    surveillance_col_realise: "Actual revenue",
    surveillance_col_ecart: "Variance",
    surveillance_total: "Total",
    surveillance_declared_at: "Declared on",
    surveillance_validated_at: "Validated on",
    surveillance_declare_btn: "Declare to Arcus Solutions",
    surveillance_validate_btn: "Validate declaration",
    surveillance_status_a_venir: "Upcoming",
    surveillance_status_a_declarer: "To declare",
    surveillance_status_declaree: "Declared",
    surveillance_status_validee: "Validated",
    surveillance_reset_title: "Change frequency?",
    surveillance_reset_warning: "Changing the frequency will remove existing periods and all entered declarations. This action is irreversible.",
    surveillance_reset_confirm: "Confirm and reset",
    create_variation: "Create a variation",
    renew_procedure: "Create a renewal procedure",
    terminate_gf: "Terminate",
    title: 'Financial Guarantee',
    nav: 'Financial Guarantee',
    tab_policy: 'The policy',
    tab_tarification_gf: 'Underwriting',
    tarif_add_period: '+ Add period',
    tarif_period: 'Period',
    tarif_date_debut: 'Start date',
    tarif_date_fin: 'End date',
    tarif_exposition: 'Exposure (€)',
    tarif_taux: 'Rate (%)',
    tarif_prime_ht: 'Net premium',
    tarif_taxe: 'Tax (9%)',
    tarif_prime_ttc: 'Gross premium',
    tarif_total: 'TOTAL GROSS PREMIUM',
    tarif_hint: 'Net premium = Exposure × Rate · Tax = 9% · Gross premium = Net + Tax',
    tab_underwriting: 'Information Collection',
    tab_documents: 'Documents',
    tab_souscription: 'Subscription documents',
    create_policy: '+ New GF policy',
    portfolio_title: 'Financial Guarantee Portfolio',
    contexte_label: 'Context of the request *',
    contexte_creation: 'Company creation',
    contexte_historique: 'Existing company',
    contexte_ajout: 'Adding Tourism activity',
    contexte_hint_creation: 'Company being created — 7 required documents',
    contexte_hint_existant: 'Existing company — 10 required documents',
    collecte_title: 'Risk Declaration — Financial Guarantee',
    tarification_placeholder_sub: 'Parameters will be configured in a future release.',
    warn_date_effet_locked: "Modification possible but sensitive — consider resetting surveillance periods if needed",
    // ── Payment Graph (onglet Arcus) ──
    tab_payment_graph: "Payment Graph",
    pg_title: "Bond Graph — Theoretical exposure",
    pg_subtitle: "Automatic risk and premium calculation from the financial forecast.",
    pg_incomplete: "Complete the “Financial forecast” (turnover table) in the Information collection tab to generate the Bond Graph.",
    pg_params_title: "Parameters from the collection",
    pg_param_acompte: "Deposit",
    pg_param_solde: "Balance",
    pg_param_reserv: "Booking in advance",
    pg_param_solde_delai: "Balance paid before departure",
    pg_months: "months",
    pg_total_bookings: "Turnover (year 1)",
    pg_param_missing: "Enter the deposit % and the number of months of advance booking in the collection for a reliable calculation.",
    pg_admin_title: "Calculation parameters (Arcus)",
    pg_rate: "Premium rate (%)",
    pg_bond_helper: "Bond level helpers (Turnover × %)",
    pg_col_month: "Month",
    pg_col_bookings: "Bookings departing",
    pg_col_cash_received: "Cash Received",
    pg_col_cash_held: "Cash Held",
    pg_col_exposure: "Exposure",
    pg_col_last_bond: "Bond N-1",
    pg_col_bond: "Bond level",
    pg_col_premium: "Premium",
    pg_year1_tag: "YR 1",
    pg_year2_tag: "YR 2 · projection",
    pg_total_year1: "TOTAL — Year 1",
    pg_annual_ht: "Annual net premium",
    pg_peak_exposure: "Peak exposure (year 1)",
    pg_annual_ttc: "Annual gross premium",
    pg_formula_cash: "deposit × Bookings(month+adv) + balance × Bookings(month+bal)",
    pg_formula_premium: "Bond level × rate ÷ 12 · Gross = Net × 1.09 (9% tax)",
    pg_last_bond_hint: "Bond N-1: empty in year 1 · filled automatically on renewal (previous year's exposure).",
    // ── Lot 1 : cotation + sections Documents ──
    pg_cotation_title: "Quote (insurance proposal)",
    pg_cotation_empty: "No quote period defined.",
    pg_generate_cotation: "Generate quote",
    pg_regenerate_cotation: "Regenerate quote",
    pg_cotation_generated: "Quote generated on",
    pg_cotation_none: "No quote generated",
    pg_cotation_confirm_title: "Generate the quote?",
    pg_cotation_confirm_desc: "The quote will be saved and the insurance proposal will become available in the Documents tab.",
    pg_cotation_confirm_btn: "Generate",
    doc_section_projet: "Insurance proposal",
    doc_section_contractuelles: "Contractual documents",
    doc_projet_ready: "Quote from",
    doc_projet_locked: "Generate the quote in the Payment Graph tab to activate the insurance proposal.",
    doc_projet_badge_todo: "To generate",
    // ── Lot 3 : déclarations + variations ──
    pg_col_declarations: "Declarations",
    pg_period_declared: "Declared period",
    pg_period_vs: "vs forecast",
    pg_over_forecast: "Above forecast",
    pg_create_variation: "Create a variation",
    pg_variation_created: "Variation created",
    pg_variations_title: "Premium variations",
    pg_variation_label: "Variation",
    pg_variation_badge_draft: "Draft",
    pg_variation_badge_done: "Generated",
    pg_variation_generate: "Generate variation premium call",
    pg_variation_regenerate: "Regenerate premium call",
    pg_variation_generated: "Premium call generated on",
    pg_variation_confirm_title: "Generate the variation premium call?",
    pg_variation_confirm_desc: "The variation premium call will be saved and will appear in the Documents tab, below the contractual documents.",
    pg_variation_confirm_btn: "Generate",
    doc_section_variations: "Variation premium calls",
    doc_variation_label: "Variation premium call",
    // ── Workflow étude/police GF ──
    etude_title: "File review",
    etude_locked_note: "Section locked — the policy is bound.",
    numero_projet: "Project number",
    date_effet_prev: "Provisional effective date",
    date_prev_locked_devis: "Locked once at quote stage.",
    step_hint_demande_pieces: "The client completes their file and submits it to Arcus.",
    step_hint_en_cours: "Reached automatically when the client submits their file.",
    step_hint_devis: "Reached when the insurance proposal is generated.",
    repasser_btn: "Revert to Request for documents",
    repasser_confirm_title: "Revert the file to Request for documents?",
    repasser_confirm_desc: "The form becomes editable by the client again; data already entered is kept. The file returns to the “Request for documents” status.",
    repasser_confirm_btn: "Revert to Request for documents",
    police_locked_note: "Section activated when the policy is bound.",
    // ── Souscription GF ──
    souscrire_btn: "Bind the policy",
    souscrire_need_date: "Enter the effective date.",
    souscrire_confirm_title: "Bind the policy",
    souscrire_confirm_desc: "Confirm the details below to create the policy. The “Policy” section will be activated and the file review locked.",
    souscrire_date_label: "Policy effective date",
    souscrire_npolice_label: "Policy number",
    souscrire_freq_label: "Monitoring frequency",
    souscrire_freq_hint: "This choice locks the frequency in the Risk Monitoring tab.",
    souscrire_confirm_btn: "Bind",
    // ── Tableau parallèle déclarations ──
    pg_group_original: "Payment Graph (forecast)",
    pg_group_declarations: "Declaration tracking",
    pg_col_updated_exposure: "Updated exposure",
    pg_col_updated_bond: "Updated bond level",
    // ── Lot 1 : bond level par périodes ──
    pg_define_bond: "Set bond level",
    pg_bond_modal_title: "Set the bond level for a period",
    pg_bond_modal_desc: "The period starts at the first uncovered month. Choose the end month and the amount: every month in the period takes this bond level.",
    pg_bond_modal_confirm: "Set period",
    pg_bond_period_start: "Start (auto)",
    pg_bond_period_end: "End of period",
    pg_bond_amount: "Bond level amount",
    pg_bond_expo_max: "Use Max Exposure:",
    pg_bond_periods_recap: "Bond level periods",
    pg_bond_periods_none: "No period defined — click “Set bond level” on the first month.",
    pg_bond_periods_incomplete: "12 months not yet covered",
    pg_bond_remove_last: "Remove last",
    pg_bond_reset: "Reset",
    // ── Lot 2 : cotation auto ──
    pg_cotation_auto_hint: "The quote is generated automatically from the bond level periods (dates + exposure + rate).",
    pg_cotation_need_bond: "First define the bond level periods in the table above.",
    pg_cotation_incomplete: "Cover all 12 months with bond level periods and set the rate to generate the quote.",
    // ── Lot 3 : déclarations mois futurs ──
    surveillance_anticipation_hint: "Anticipation allowed — editable until its declaration, then locked.",
    // ── Lot 4 : section variations ──
    pg_variations_hint: "Variations are computed automatically from validated over-forecast declarations, split by bond level period.",
    pg_var_peakbond_title: "Peak bond % per period",
    pg_var_period: "Period",
    pg_var_peakbond: "Peak bond %",
    pg_var_booking_initial: "Initial Booking Departing",
    pg_var_booking_new: "New Booking Departing",
    pg_var_increase: "Increase",
    pg_var_none: "No variation — no validated over-forecast declaration yet.",
    pg_var_value: "Variation value",
    pg_var_days: "Days",
    pg_variation_see_section: "→ see the Variations section",
    pg_chart_title: "Bond graph — curves",
    surveillance_declare_confirm_title: "Declare to Arcus Solutions?",
    surveillance_declare_confirm_desc: "The volumes below will be sent to Arcus Solutions for validation. Once confirmed, this period will be permanently locked and can no longer be edited.",
    surveillance_declare_confirm_btn: "Confirm declaration",
    pg_var_appel_title: "Variation premium call",
    pg_var_appel_pending_desc: "The pending variations below will be grouped into a single premium call.",
    pg_var_appel_none: "No variation awaiting a premium call.",
    pg_var_appel_generate: "Generate the variation premium call",
    pg_var_appel_history: "Generated calls",
    pg_var_appel_confirm_title: "Generate the variation premium call?",
    pg_var_appel_confirm_desc: "Select the variations to include in this premium call. Unchecked variations will remain pending for a future call.",
    pg_var_appel_confirm_btn: "Generate the premium call",
    pg_var_badge_covered: "Included in the call of",
    pg_var_badge_pending: "Awaiting call",
    pg_table_title: "Payment graph",
    surveillance_declare_validate_btn: "Declare and validate",
    surveillance_declare_validate_desc: "You are declaring these volumes on behalf of the client: the period will be immediately declared AND validated, then permanently locked. The Payment Graph will be updated.",
    pf_title: "Financial Guarantee Portfolio",
    pf_contracts: "contracts",
    pf_col_month: "Creation month",
    pf_col_status: "Status",
    pf_col_name: "File",
    pf_col_country: "Country",
    pf_col_broker: "Broker",
    pf_col_prev_date: "Expected date",
    pf_direct: "Direct",
    pf_search: "Client / Policy No…",
    pf_filter: "Filter",
    pf_filter_search: "Search…",
    pf_filter_all: "Select all",
    pf_filter_none: "Deselect all",
    pf_filter_clear_all: "Clear all filters",
    pf_no_rows: "No file matches the filters.",
    pg_mgmt_fees: "Management fees",
  },



  account: {
    title: "My account",
    breadcrumb: "PERSONAL SPACE",
    profile: "My profile",
    change_password: "Change my password",
    current_password: "Current password",
    update_password_btn: "Update password",
    password_changed: "Password successfully changed.",
    field_nom: "Full name",
    field_email: "Email",
    field_role: "Role",
  },
  utilisateurs: { col_last_login: "Last login", never_connected: "Never logged in",
    create_mode_label: "Account creation method",
    mode_link: "Send an activation link",
    mode_password: "Set a password",
    password_label: "Password",
    password_ph: "At least 8 characters",
    password_info: "The account will be immediately usable with this password. No email will be sent.",
    pwd_too_short: "The password must be at least 8 characters.",
    title: "User accounts",
    count: "account",
    count_plural: "accounts",
    create_btn: "+ Create a user",
    search_placeholder: "Search by name or email…",
    filter_all: "All",
    statut_actif: "Active",
    statut_inactif: "Inactive",
    breadcrumb: "USER ACCOUNTS",
    new_title: "New account",
    edit_title: "Edit account",
    field_nom: "Full name",
    field_email: "Email",
    field_role: "Status (role)",
    field_client: "Attached client",
    field_courtier: "Linked broker",
    field_statut: "Account state",
    create_info: "An activation email will be sent to the address. The user will set their password via the received link.",
    create_and_send: "Create and send link",
    send_reset: "Send a password reset link",
    reset_password: "Reset password",
    reset_sent_simple: "Reset link sent",
    saved: "Changes saved",
    created: "Account created — email sent",
    delete_confirm: "Permanently delete the account of",
  },
  docs_souscription: {
    title: 'Subscription documents',
    subtitle: 'Documents to collect before binding',
    doc_projet_signe: 'Signed insurance quote',
    doc_certificat: 'Registration certificate',
    doc_rib: 'IBAN',
    doc_releve_sinistre: 'Claims statement',
    rib_condition: 'Required — non-annual payment frequency',
    releve_condition: 'Required — risk previously insured',
    add_doc: '+ Add required document',
    add_doc_placeholder: "e.g. Previous insurer certificate",
    add_doc_label: 'Document name',
    upload_btn: 'Upload',
    replace_btn: 'Replace',
    preview_btn: 'Preview',
    accept_btn: 'Accept',
    refuse_btn: 'Refuse',
    status_attente: 'Pending',
    status_uploade: 'Uploaded',
    status_accepte: 'Accepted',
    status_refuse: 'Refused',
    refuse_category: 'Refusal category *',
    refuse_category_placeholder: '— Select a category —',
    refuse_detail: 'Additional details (optional)',
    refuse_email_btn: '📧 Send refusal email to client',
    refuse_email_title: 'Email — Refused documents',
    refuse_email_copy: 'Copy',
    refuse_email_open: 'Open in mail client',
    refuse_email_copied: 'Copied!',
    refuse_email_subject: 'Your file — Documents to be regularised',
    refuse_no_refused: 'No documents refused at this time.',
    refuse_title: 'Refusal justification',
    refuse_label: 'Reason for refusal *',
    refuse_placeholder: "e.g.: Illegible document, wrong document…",
    refuse_email_note: 'This comment will be sent by email to the client.',
    refuse_confirm: 'Confirm refusal',
    locked_msg: 'Accepted',
    rejected_comment: 'Reason:',
    completion: 'accepted',
    accept_confirm: 'Accept this document?',
    file_size: 'Max 20MB — PDF, images, Word',
    unlock_btn: 'Unlock',
    unlock_confirm: 'Reset this document to pending validation?',
    doc_gf_cert_immat: 'Registration certificate',
    doc_gf_statuts: 'Company articles of association',
    doc_gf_cv_dirigeant: "Director's CV",
    doc_gf_piece_id: "Director's identity document",
    doc_gf_presentation_projet: 'Project presentation',
    doc_gf_previsionnel: 'Detailed business forecast',
    doc_gf_cgv: 'General terms and conditions of sale',
    doc_gf_presentation_activites: 'Activity presentation',
    doc_gf_previsionnel_annuel: 'Business forecast for the guaranteed year',
    doc_gf_bilan_cr: 'Latest detailed balance sheet and P&L',
    doc_gf_attestation_rcpro: 'Current PI insurance certificate',
    doc_gf_attestation_fonds: 'Held funds peak certificate',
    readonly_banner: 'Read-only view — upload and preview only',
    broker_readonly: 'As a broker, you can only view client records.',
    address_siege: 'Registered address',
    broker_status_locked: 'Prospect — status defined by Arcus underwriter',
    accepted_label: 'accepted',
    required_label: 'Required',
    delete_btn: '🗑 Delete',
    doc_contrat_reservation: 'Copy of the booking contract with the agency',
    doc_preuve_paiement: 'Proof of payment(s)',
    doc_bon_voucher: 'Unused voucher (if applicable)',
    delete_confirm: 'Delete this document?',
    // ── Verrou pack + ZIP (Lot C) ──
    lock_pack: "Lock the documents",
    unlock_pack: "Unlock the documents",
    generate_zip: "Generate ZIP pack",
    lock_confirm: "Lock the document pack? No further changes will be possible until it is unlocked.",
    unlock_pack_confirm: "Unlock the document pack to allow changes?",
    zip_confirm: "Generate the document pack ZIP?",
    zip_coming: "ZIP generation coming soon.",
    pack_locked_note: "Documents locked.",
    pack_ready_note: "All required documents are validated.",
  },
  chat: {
    open: "Open chat",
    minimize: "Minimize",
    with_arcus: "Chat with Arcus",
    no_conv: "No conversation",
    select_conv: "Select a conversation",
    no_conv_yet: "No conversations yet",
    no_messages_yet: "No messages",
    send_first_message: "Send your first message below",
    message_placeholder: "Write a message…",
    participants: "members",
    you: "You",
    add: "Add",
    add_admin: "Add an Arcus member",
    remove_participant: "Remove this member",
    confirm_remove_participant: "Remove this member from the conversation?",
    all_admins_already: "All admins are already members",
    loading_error: "Conversation unavailable",
    back_list: "Back to conversations",
  },
  it_delete: {
    title: "God Mode — Force delete",
    god_mode: "GOD MODE — IT",
    entity_client: "Client",
    entity_police: "Policy",
    entity_intermediaire: "Intermediary",
    about_to_delete: "You are about to permanently delete",
    also_deleted: "LINKED ITEMS DELETED IN CASCADE",
    no_cascade: "No linked items to delete.",
    polices: "Policies",
    amendements: "Amendments",
    renouvellements: "Renewals (links cleared)",
    clients_unlinked: "Linked clients (will become direct)",
    irreversible: "This action is irreversible.",
    confirm_btn: "Permanently delete",
    impact_error: "Could not compute impact.",
    delete_error: "Deletion failed.",
    dossiers_linked: "Linked claim files (payments affected)",
  },

  prestataires_section: {
    title: "Suppliers & Tour Operators",
    breadcrumb: "SUPPLIERS",
    count: "supplier",
    count_plural: "suppliers",
    contacts_count: "contact",
    contacts_count_plural: "contacts",
    create_btn: "+ New supplier",
    new_title: "New supplier",
    search_placeholder: "Search by name, city, company number…",
    iban_set: "IBAN set",
    tab_infos: "The supplier",
    tab_contacts: "Contacts",
    tab_bank: "Banking information",
    field_nom: "Supplier name",
    field_adresse_1: "Address line 1",
    field_adresse_2: "Address line 2",
    field_code_postal: "Postcode",
    field_ville: "City",
    field_numero_entreprise: "Company number",
    field_notes: "Internal notes",
    field_numero_compte: "Account number",
    field_iban: "IBAN",
    field_swift: "SWIFT / BIC code",
    adresse_placeholder: "Number and street",
    numero_placeholder: "VAT number, company ID…",
    notes_placeholder: "Useful info: type of business, payment terms…",
    bank_warning: "This information will be auto-used when paying claims with travel kept option.",
    err_nom: "Supplier name is required.",
  },

  phase_b: {
    count: "dossier",
    count_plural: "dossiers",
    empty: "No dossier in this category.",
    col_numero: "Dossier / Procedure n°",
    col_agence: "Agency",
    col_beneficiaire: "Beneficiary",
    col_montant: "Amount",
    col_date_action: "Date",
    col_par: "By",
    confirm_title: "Confirm action?",
    refus_banner_title: "Dossier refused by Manager — reason:",
    send_validation_title: "Send to Manager for validation",
    send_validation_desc: "Once sent, the dossier moves to pending Manager validation before payment.",
    send_validation_btn: "Send for validation",
    manager_validation_title: "Manager validation required",
    manager_validation_desc: "This dossier is ready for final validation before being passed to Accounts.",
    validate_btn: "Approve",
    refuse_btn: "Refuse",
    refuse_modal_title: "Refusal reason",
    refuse_modal_desc: "The dossier will return to \"In progress\" status. The reason will be visible to the Admin.",
    refuse_motif_placeholder: "Specify the reason for refusal…",
    refuse_confirm_btn: "Confirm refusal",
    ready_to_pay_title: "Ready for payment",
    ready_to_pay_desc: "Manager has approved this dossier. Accounts can now mark the payment as done.",
    mark_paid_btn: "Mark as paid",
    mark_paid_confirm_title: "Confirm payment done?",
    mark_paid_confirm_desc: "Once confirmed, the dossier moves to \"Payment done\" status and is locked.",
    mark_paid_confirm_btn: "Confirm payment",
  },
  pending_validation: {
    title: "Pending Manager validation",
    subtitle: "Dossiers sent by Admins, awaiting final validation by a Manager.",
  },
  pending_payment: {
    title: "Pending payment",
    subtitle: "Dossiers validated by Manager, awaiting payment by Accounts.",
    action_mark_paid: "Mark as paid",
    confirm_mark_paid: "Mark this dossier as paid:",
    download_btn: "Generate pending payments file",
  },
  pending_balances: { col_received: "Received", col_remaining: "Remaining",
    title: "Pending balances",
    subtitle: "Balances still to be collected from travellers",
    download_btn: "Generate Excel file",
    downloading: "Generating…",
    empty: "No funds call generated yet.",
    paid: "Paid",
    unpaid: "Pending",
    col_file: "File no.",
    col_agency: "Agency",
    col_beneficiary: "Beneficiary",
    col_generated: "Generated on",
    col_deadline: "Deadline",
    col_balance: "Balance due",
    col_paid: "Status",
  },
  closed_dossiers: {
    title: "Closed dossiers",
    subtitle: "Paid and closed dossiers.",
    download_btn: "Download claim summary",
  },

  phase_c: {
    section_title: "Suppliers to pay (trip maintained)",
    section_subtitle: "Select one or more suppliers to pay so the client can keep the trip.",
    add_prestataire: "Add supplier",
    prestataire_num: "Supplier ",
    select_prestataire: "Supplier",
    select_placeholder: "Choose a supplier",
    amount: "Amount",
    reference: "Payment reference",
    reference_placeholder: "e.g. Invoice n°…",
    description: "Description",
    description_placeholder: "e.g. Hotel 2 nights, Return flight…",
    bank_locked: "Bank details (locked — from central supplier record)",
    location: "Location",
    total: "Total supplier payments",
    empty: "No supplier added. Click \"Add supplier\" to start.",
  },

  voyageur_intro: {
    title: "Welcome to your claim request area",
    body: "Complete the information relating to your travel file, and submit the documents required to process your claim request.",
    submit_title: "Is your file complete?",
    submit_desc: "Once submitted, your file will be sent to our teams for processing.",
    submit_btn: "Submit my file",
    submit_confirm_title: "Submit your file?",
    submit_confirm_desc: "Check that all your information and supporting documents are correct. After submission, your file will move to processing.",
    submit_confirm_btn: "Confirm submission",
    status_section: "Your file status",
    status_msg_attente: "We are waiting for you to complete your information, submit your supporting documents, and then submit your file.",
    status_msg_traitement: "Your file is being processed by our teams. You will be informed of its progress.",
    status_msg_validation: "Your file is awaiting final validation by our team.",
    status_msg_paiement: "Your file has been validated. Payment is being processed.",
    status_msg_solde_paye: "The balance has been received. Your file is still being processed.",
    status_msg_realise: "Payment has been completed. Your file is closed.",
    status_msg_decline: "Unfortunately your file could not be accepted. Contact us for more information.",
  },

  phase_d4: {
    lock: "Lock",
    unlock: "Unlock",
    locked: "Locked",
    lock_paiements: "Lock payments",
    unlock_paiements: "Unlock payments",
    date_naissance: "Beneficiary date of birth",
    sanction_title: "Sanctions screening",
    sanction_btn: "Sanctions screening completed",
    sanction_done: "Sanctions screening done — payments are locked.",
    sanction_undo: "Remove lock (Manager)",
    validation_checklist: "Conditions to request validation",
    cond_paiements_locked: "Payments locked",
    cond_docs_approved: "All supporting documents approved",
    cond_sanction: "Sanctions screening completed",
    cond_facture: "Supplier invoice(s) uploaded",
    cond_appel_fonds_paye: "Funds call marked as paid",
    request_validation_title: "Request file validation",
    request_validation_desc: "All conditions are met. The file will be locked and sent to the Manager.",
    request_validation_btn: "Request validation",
    validation_locked_hint: "The request-validation button will appear once all the conditions above are met.",
    decline_btn: "Decline file",
    decline_modal_title: "Decline this file?",
    decline_modal_desc: "The file will move to \"Declined\" status and be closed. You may provide a reason.",
    decline_motif_placeholder: "Reason for refusal (optional)…",
    decline_confirm_btn: "Confirm refusal",
  },
  phase_d4_facture: {
    title: "Supplier invoice",
    upload: "Upload invoice",
    replace: "Replace",
   view: "View", save_row_first: "Save this provider first to attach its invoice.",},
  phase_d5: {
    marquer_paye: "Mark as paid",
    annuler_paye: "Cancel payment",
    paye_badge: "Paid",
  },
  phase_solde: { af_confirm_btn: "Confirm funds call sent", af_confirm_title: "Confirm the funds call was sent?", af_confirm_desc: "This moves the case to “Awaiting balance payment”, permanently shows the Balance management section and locks generation of a new funds call. This action is irreversible.", af_confirmed_badge: "Funds call confirmed",
    admin_valid_title: "Administrative file validation",
    admin_valid_desc: "Confirm that the information and supporting documents are compliant (form validation).",
    admin_valid_done: "Administrative file validated. You can generate the funds call.",
    admin_valid_btn: "Validate administrative file",
    admin_valid_cancel: "Cancel validation",
    admin_valid_need_docs: "All supporting documents must be accepted before validation.",
    gen_blocked: "Validate the administrative file to generate the funds call",
    section_title: "Balance payment management",
    balance_due: "Balance due",
    deadline: "Payment deadline",
    received_title: "Payments received",
    received_empty: "No payment received recorded.",
    add_received: "Add a payment received",
    col_date: "Reception date",
    col_emetteur: "Payment sender",
    col_emetteur_ph: "Sender name",
    col_montant: "Amount paid",
    total_received: "Total funds received",
    remaining: "Remaining to receive",
    mark_paid_btn: "Mark as paid",
    unlock_btn: "Unlock",
    confirm_recu_btn: "Confirm balance reception",
    recu_confirmed: "Balance reception confirmed",
    recu_cancel: "Cancel confirmation",
    save_confirm_title: "Save received payments?",
    save_confirm_desc: "The entered payment fields will be locked. You can unlock them afterwards if needed.",
    save_confirm_btn: "Save and lock",
    recu_confirm_title: "Confirm balance reception?",
    recu_confirm_desc: "The balance is fully received. This action marks the file as paid.",
    recu_confirm_btn: "Confirm reception",
    cond_prestataire_facture: "At least one provider saved with its invoice",
    validation_lock_banner: "File sent for validation. It is locked until the Manager decides.",
    send_validation_title: "Send for validation",
    send_validation_desc: "Send the file to the Manager for validation of provider payments.",
    send_validation_btn: "Send for validation",
    send_validation_confirm_title: "Send the file for validation?",
    send_validation_confirm_desc: "The file will be sent to the Manager and fully locked until their decision.",
    send_validation_confirm_btn: "Send for validation",
  },
  phase_d4b: {
    entreprise_nom: "Company name",
    resp_nom: "Legal representative last name",
    resp_prenom: "Legal representative first name",
    date_naissance: "Date of birth",
    nationalite: "Nationality",
    sanction_label: "Sanctions screening completed",
    sanction_confirmed: "Sanctions screening confirmed",
  },

  gestiondoc: {
    title: "Document management",
    subtitle: "Document templates — upload a new version whenever a template changes.",
    add_template: "Add a template",
    cat_gf: "Financial Guarantee",
    cat_rc_pro: "Professional Liability",
    cat_commun: "Common",
    cat_sinistre: "Claims",
    no_file: "No file",
    download: "Download",
    upload_new: "New version",
    history: "History",
    systeme_tag: "Catalog",
    custom_tag: "Custom",
    inactive: "Inactive",
    active: "Active",
    delete_confirm: "Delete this custom template?",
    empty: "No template.",
    hist_title: "Version history",
    current_tag: "Current",
    modal_upload_title: "Upload a new version",
    modal_file: ".docx or .pdf file",
    modal_notes: "Version note (optional)",
    modal_upload_btn: "Upload",
    drop_hint: "Drag a file here or click to browse",
    add_title: "New template",
    add_nom: "Template name",
    add_categorie: "Category",
    add_desc: "Description",
    add_btn: "Create template",
  },
};

export default en;
